import { INIT_DATA } from 'constants/default';
import axiosClient from './axiosClient';

const notificationApi = {
  create: (data) => {
    const url = '/notifications';
    return axiosClient.post(url, data);
  },
  /**
   * @param {{[x:string]: any}} [params]
   * @returns {Promise<typeof INIT_DATA>}
   */
  get: (params) => {
    const url = '/notifications';

    return axiosClient.get(url, { params });
  },
  delete: (id) => {
    const url = `/notifications/${id}`;
    return axiosClient.delete(url);
  },
  getById: (id) => {
    const url = `/notifications/${id}`;
    return axiosClient.get(url);
  },
  edit: (id, data) => {
    const url = `/notifications/${id}`;
    return axiosClient.put(url, data);
  },
  getEvent: () => {
    const url = '/notifications/notification-event';
    return axiosClient.get(url);
  },
  getData: (params) => {
    const url = '/notifications/notification-data';
    return axiosClient.get(url, { params });
  },
  getUserType: () => {
    const url = '/notifications/notification-user-type';
    return axiosClient.get(url);
  },
  getHistory: (params) => {
    const url = '/notifications/get-list-notification-log';
    return axiosClient.get(url, { params });
  },
  /**
   * @param {{[x:string]: any}} [params]
   * @returns {Promise<typeof INIT_DATA & {userGridColumn: null}>}
   */
  getHistoryByPost: (data, { params }) => {
    const url = '/notifications/get-list-notification-log';
    return axiosClient.post(url, data, { params });
  },
  getStatus: () => {
    const url = '/notifications/notification-log-status';
    return axiosClient.get(url);
  },
  getHistoryById: (id) => {
    const url = `/notifications/notification-log/${id}`;
    return axiosClient.get(url);
  },
  resend: (id) => {
    const url = `/notifications/resend-email/${id}`;
    return axiosClient.post(url);
  },
  clearHistory: () => {
    const url = '/notifications/clean-notification-log';
    return axiosClient.post(url);
  },
  notificationalert: (userid) => {
    const url = `/notifications/get-user-notifications/${userid}`;
    return axiosClient.get(url);
  },
  notificationread: (messageid, body) => {
    const url = `/notifications/update-alert-status/${messageid}`;
    return axiosClient.put(url, body);
  },
  CloneNotification: (id) => {
    const url = `/notifications/notification-clone/`;
    return axiosClient.post(url, { id });
  },
  statusUpdate: (data) => {
    const url = '/notifications/update-notifications-status';
    return axiosClient.put(url, data);
  },
  getDemeritPoints: (params) => {
    const url = '/demerit-points';
    return axiosClient.get(url, { params });
  },
  /**
   *
   * @param {*} data
   * @param {*} param
   * @returns
   */
  DemeritByPost: (data, { params, headers }) => {
    const url = `/demerit-points/get-demerits`;
    return axiosClient.post(url, data, { params, headers });
  },
  getDemeritByPost: (data, { params, headers }) => {
    const url = '/demerit-points/get-demerits';
    return axiosClient.post(url, data, { params, headers });
  },
};

export default notificationApi;
